'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowUpRightIcon } from '@heroicons/react/24/outline';
import { Highlight } from 'react-instantsearch';
import type { HitItem } from '@src/components/SearchModal/types';
interface SearchModalHitsProps {
  items: HitItem[];
  handleSuggestionClick: (suggestion: string) => void;
}
export function SearchModalHits(props) {
  const $ = _c(7);
  const {
    items,
    handleSuggestionClick
  } = props;
  let t0;
  if ($[0] !== handleSuggestionClick || $[1] !== items) {
    let t1;
    if ($[3] !== handleSuggestionClick) {
      t1 = hit => {
        const label = hit.query ?? String(hit.objectID);
        return <li key={hit.objectID}><button onClick={() => handleSuggestionClick(label)} className="flex w-full items-center justify-between rounded-lg py-0.5 text-body-base text-bodi-black"><Highlight hit={hit} attribute="query" highlightedTagName="strong" classNames={{
              highlighted: "font-bold bg-transparent",
              nonHighlighted: "text-bodi-black"
            }} /><ArrowUpRightIcon className="size-3.5 shrink-0 text-bodi-gray-butters" /></button></li>;
      };
      $[3] = handleSuggestionClick;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = items.map(t1);
    $[0] = handleSuggestionClick;
    $[1] = items;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[5] !== t0) {
    t1 = <ul>{t0}</ul>;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}